import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { HistoryPuzzle } from '../api/types';

interface HistoryState {
  history: HistoryPuzzle[];
  loading: boolean;
  error: string | null;
}

/** Tages-Historie der letzten N aufgedeckten Rätsel. */
export function useHistory(limit = 20): HistoryState {
  const [state, setState] = useState<HistoryState>({ history: [], loading: true, error: null });

  useEffect(() => {
    let cancelled = false;
    api
      .get<HistoryPuzzle[]>(`/stats/history?limit=${limit}`)
      .then((res) => {
        if (cancelled) return;
        setState({ history: res.data, loading: false, error: null });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ history: [], loading: false, error: 'Historie konnte nicht geladen werden' });
      });

    return () => {
      cancelled = true;
    };
  }, [limit]);

  return state;
}
